(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c_product-carousel"] && !Shopify.designMode) return;
  try {
    class CedarwoodProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prevBtn = this.querySelector('[data-carousel-prev]');
      this.nextBtn = this.querySelector('[data-carousel-next]');
      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      this.maxScroll = 0;
      this.prevBtn.addEventListener('click', () => this.scrollByPage(-1));
      this.nextBtn.addEventListener('click', () => this.scrollByPage(1));
      // スクロール中は scrollLeft のみ読む。寸法依存の maxScroll はリサイズ時だけ再計測
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.track);
      this.measure();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    measure() {
      this.maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      this.updateButtons();
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth * 0.9, behavior: 'smooth' });
    }

    updateButtons() {
      this.prevBtn.disabled = this.track.scrollLeft <= 0;
      this.nextBtn.disabled = this.track.scrollLeft >= this.maxScroll;
    }
  }

  if (!customElements.get('cedarwood-product-carousel')) {
    customElements.define('cedarwood-product-carousel', CedarwoodProductCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
